import TituloNegrito from './TituloNegrito';
import CardProdutoA2A2 from './CardProdutoA2A2';

function ProdutosCertificadosA2A2({ produtos, exibirMenu, resolucaoMobile }) {
    return (
        <>
            <TituloNegrito texto={'Produtos certificados'}/>
            <div style={{ width: '80vw', gap: '20px' }} className='mb-2 d-flex flex-wrap align-items-center justify-content-center'>
                {produtos?.map((produto) => <CardProdutoA2A2 key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile}/>)}
            </div>
        </>
    );
}
export default ProdutosCertificadosA2A2;
